/*
|--------------------------------------------------------------------------
| Component: FormField.jsx
| Author: Sayed Ahmed
| Description: Generic form input component with label, validation, and support for custom children.
|--------------------------------------------------------------------------
*/

import React from "react";
import { useTranslation } from "react-i18next";

export default function FormField({
  label,
  name,
  register,
  required,
  type = "text",
  errors,
  className = "",
  placeholder = "",
  value,
  onChange,
  children,
  disabled = false,
}) {
  const { t } = useTranslation();

  // Determine input props based on usage: react-hook-form or manual control
  const inputProps = register
    ? {
        ...register(name, {
          required: required ? t("Field is required") : false,
        }),
      }
    : {
        value,
        onChange,
        name,
      };

  return (
    <div className="form-group mb-3">
      {/* Optional label */}
      {label && (
        <label htmlFor={name}>
          {t(label)} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {/* Either render children (custom field) or default input */}
      {children ? (
        children
      ) : (
        <input
          id={name}
          type={type}
          className={`form-control ${className}`}
          placeholder={placeholder}
          disabled={disabled}
          {...inputProps}
        />
      )}

      {/* Validation error display */}
      {errors?.[name]?.message && (
        <p className="text-red-600 text-sm">{t(errors[name]?.message)}</p>
      )}
    </div>
  );
}
